import request from '@/utils/request.js'
import Vue from 'vue'

//登陆
export function shopLogin (data) {
  return request({
    url: Vue.prototype.PROFILE_base + 'user/login',
    method: 'post',
    data: data
  })
}

//注册发送验证
export function sendCode (data) {
  return request({
    url: Vue.prototype.PROFILE_base + 'user/sms',
    method: 'post',
    data: data,
  })
}

//用户注册
export function shopRegister (data) {
  return request({
    url: Vue.prototype.PROFILE_base + 'user/register',
    method: 'post',
    data: data
  })
}

//店铺信息
export function getShopInfo () {
  return request({
    url: Vue.prototype.PROFILE + 'shops/getShopInfo',
    method: 'get',
  })
}

//店铺信息
export function getDictItems (data) {
  return request({
    url: Vue.prototype.PROFILE_base + 'getDictItems',
    method: 'get',
    queryType: 'code',
    params: data
  })
}
//用户信息
export function getUserInfo (data) {
  return request({
    url: Vue.prototype.PROFILE_base + 'user/getUserInfo',
    method: 'get',
    params: data
  })
}
//选择门店
export function setDefaultShop (data) {
  return request({
    url: Vue.prototype.PROFILE_base + 'user/setDefaultShop',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js